import React, { Component } from 'react';
import { FaPause, FaSortDown, FaSortUp } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import api from '../../../axios-local-api';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Modal from '../../../components/UI/Modal/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { sortDataByKey } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import classes from './MoveDevicesToGroup.css';
import SelectDropdown from '../../../shared/SelectDropdown/SelectDropdown';

export class MoveDevicesToGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrow: true,
      deviceMacs: new Map(),
      action: '',
      result: null,
      confirmModal: false,
      selectedGroupId: '',
      noGroupsMsg: false,
      currentRecords: this.buildDeviceGroupData(
        this.props.groupDetails,
        this.props
      ),
      sortBy: 'deviceSignalStatus',
      sortDirection: 'asc',
    };
    this.moveDevicesGroupHandler = this.moveDevicesGroupHandler.bind(this);
    this.handleSelectedGroup = this.handleSelectedGroup.bind(this);
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.loading !== this.props.loading) {
      this.setState({
        currentRecords: null,
        sortDirection: 'asc',
      });
    }

    if (
      !this.state.currentRecords &&
      nextProps.groupDetails &&
      nextProps.groupDetails.devices
    ) {
      // console.log(this.buildDeviceGroupData(nextProps.groupDetails, nextProps), 'bui;d data')
      this.setState(
        {
          currentRecords: this.buildDeviceGroupData(
            nextProps.groupDetails,
            nextProps
          ),
          sortDirection: 'asc',
        },
        () => {
          this.sortTable('deviceSignalStatus');
        }
      );
    }
  }

  componentDidMount() {
    if (this.props.selectedDeviceMac !== undefined) {
      this.setState((prevState, props) => {
        return {
          deviceMacs: prevState.deviceMacs.set(
            this.props.selectedDeviceMac,
            true
          ),
        };
      });
    }
    let moveDevices = [];
    if (this.props.deviceGroups) {
      this.props.deviceGroups.forEach((group) => {
        if (this.props.groupDetails.id !== group.id) {
          moveDevices.push(group);
        }
      });
      if (moveDevices.length > 0) {
        this.setState({
          selectedGroupId: moveDevices[0].id,
        });
      } else {
        this.setState({
          noGroupsMsg: true,
        });
      }
    }
    this.setState(
      {
        currentRecords: this.buildDeviceGroupData(
          this.props.groupDetails,
          this.props
        ),
        sortDirection: 'asc',
      },
      () => {
        this.sortTable('deviceSignalStatus');
      }
    );
  }
  componentWillUpdate() { }
  componentDidUpdate() { }

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  resetUpArrow() {
    this.setState({
      upArrow: false,
    });
  }

  handleMoveDeviceCheckBox = (e) => {
    let deviceMac = e.target.value;
    let checked = e.target.checked;
    this.setState((prevState, props) => {
      return {
        deviceMacs: prevState.deviceMacs.set(deviceMac, checked),
      };
    });
  };
  handleSelectedGroup = (e) => {
    let group = e.value;
    this.setState({
      selectedGroupId: group,
    });
  };

  getDeviceModel = (device) => {
    if (!this.props.advancedDeviceIds) {
      return 'N/A';
    }
    let adid = this.props.advancedDeviceIds[device.mac];
    if (!adid.advancedDeviceId) {
      return 'N/A';
    }
    return adid.advancedDeviceId.model;
  };
  getDeviceGroups = () => {
    let groupMap = {};
    if (this.props.deviceGroups) {
      this.props.deviceGroups.forEach((group) => {
        if (!group.devices) return;
        group.devices.forEach((device) => {
          groupMap[device.mac] = group.nickname;
        });
      });
    }
    return groupMap;
  };

  getDeviceName = (device) => {
    let deviceName;
    if (
      !device.nickname ||
      device.nickname === undefined ||
      (device.nickname && !device.nickname.length) ||
      device.nickname === null
    ) {
      deviceName = device.name;
    } else {
      if (device.nickname.indexOf('|') !== -1) {
        deviceName = device.nickname.slice(
          device.nickname.indexOf('|') + 1,
          device.nickname.length
        );
      } else deviceName = device.nickname;
    }

    if (deviceName === undefined || deviceName.length === 0) {

      if (device.mac) {
        if (this.props.advancedDeviceIds && this.props.advancedDeviceIds[device.mac] && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']) {
          if (this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['modelAccuracyLevel']
            && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
            deviceName = this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['model'] ? this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['model'] : (this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['type'] ? this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['type'] : '');
          }
        }
        if ((deviceName === undefined || deviceName.length === 0) && this.props.advancedDeviceIds && this.props.advancedDeviceIds[device.mac] && this.props.advancedDeviceIds[device.mac]['advancedDeviceId']) {
          deviceName = this.props.advancedDeviceIds[device.mac]['advancedDeviceId']['dhcpHostname'];
        }
        if (deviceName === undefined || deviceName.length === 0) {
          deviceName = device.mac;
        };
      }
      if (deviceName === undefined || deviceName.length === 0) {
        deviceName = "Unknown";
      }
    }
    return deviceName;
  };

  getDeviceModel = (device) => {
    if (!this.props.advancedDeviceIds) {
      return 'N/A';
    }
    let adid = this.props.advancedDeviceIds[device.mac];
    if (!adid.advancedDeviceId) {
      return 'N/A';
    }
    return adid.advancedDeviceId.model;
  };

  getSignalStatus = (element) => {
    let deviceSignalStatus = 'Disconnected';
    let status,
      paused = 'unpaused';
    if (element && element.freeze.frozen === true) {
      paused = 'paused';
    }
    if (element.health && element.health.status) {
      status =
        element.health.status.charAt(0).toUpperCase() +
        element.health.status.slice(1);
    } else {
      status = 'Disconnected';
    }
    if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.freeze.frozen === true
    ) {
      status = 'Paused';
      deviceSignalStatus = 'Paused';
    } else if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      element.capabilities
    ) {
      deviceSignalStatus = status;
    } else if (
      element.connectionState &&
      element.connectionState === 'connected' &&
      !element.capabilities
    ) {
      deviceSignalStatus = status;
    }
    return { deviceSignalStatus, paused };
  };

  sortTable = (propertyName) => {
    const { sortDirection, currentRecords } = this.state;
    const records = sortDataByKey(currentRecords, propertyName, sortDirection);
    this.setState({
      currentRecords: records,
      sortDirection:
        sortDirection === '' || sortDirection === 'desc' ? 'asc' : 'desc',
      sortBy: propertyName,
    });
  };

  buildDeviceGroupData(groupDetails = {}, nextProps) {
    let deviceGroups = this.getDeviceGroups() || {};
    return (
      groupDetails &&
      groupDetails.devices &&
      groupDetails.devices.map((device) => {
        const { deviceSignalStatus = '', paused = '' } =
          this.getSignalStatus(device);
        device.deviceName = this.getDeviceName(device) || '';
        device.currentGroup = deviceGroups[device.mac] || 'Ungrouped';
        device.deviceModel = this.getDeviceModel(device) || '';
        device.deviceSignalStatus = deviceSignalStatus;
        device.paused = paused;
        return device;
      })
    );
  }

  renderRowData(type) {
    const { devices } = this.props;
    let deviceGroups = this.getDeviceGroups();
    const { currentRecords } = this.state;

    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: '#6F777E',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
    };
    return (
      currentRecords &&
      currentRecords.map((data) => {
        let deviceGroupName = deviceGroups[data.mac];



        if (!deviceGroupName) {
          deviceGroupName = 'Ungrouped';
        }
        let status;
        if (data.health && data.health.status) {
          status =
            data.health.status.charAt(0).toUpperCase() +
            data.health.status.slice(1);
        } else {
          status = 'Disconnected';
        }

        let paused = '';
        if (data.freeze.frozen === true) {
          paused = <FaPause color={'gray'} />;
        }
        let statusColor, statusClass;
        if (status === 'N/A') {
          statusColor = { color: 'red' };
          statusClass = classes.poor;
        } else {
          statusColor = {
            color: data.health
              ? colorCode[data.health.status]
              : colorCode.disconnected,
          };
          statusClass = data.health
            ? classes[data.health.status]
            : classes.disconnected;
        }
        let colorDot;
        if (data.deviceSignalStatus === 'Calculating') {
          colorDot = (
            <div
              className={classes.colorDot}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div className={classes.Calculating}></div>
              <div style={{ width: '10px' }} />
              <div style={{ color: colorCode.calculating }}>{status}</div>
            </div>
          );
        } else if (
          data.connectionState &&
          data.connectionState === 'connected' &&
          data.freeze.frozen === true
        ) {
          status = 'Paused';
          colorDot = (
            <div
              className={classes.colorDot}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div className={classes.Paused}></div>
              <div style={{ width: '10px' }} />
              <div>Paused</div>
            </div>
          );
        } else if (
          data.connectionState &&
          data.connectionState === 'connected' &&
          data.capabilities
        ) {
          colorDot = (
            <div
              className={classes.colorDot}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div
                className={
                  status === 'Poor' || status === 'Fair' ? classes.NotConnected : classes.Connected
                }
              ></div>
              <div style={{ width: '10px' }} />
              <div
                style={{
                  color:
                    status === 'Poor' || status === 'Fair' ? colorCode.poor : colorCode.connected,
                }}
              >
                {status}
              </div>
            </div>
          );
        } else if (
          data.connectionState &&
          data.connectionState === 'connected' &&
          !data.capabilities
        ) {
          colorDot = (
            <div
              className={classes.colorDot}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div className={classes.NotConnected}></div>
              <div style={{ width: '10px' }} />
              <div styles={{ color: colorCode.disconnected }}>{status}</div>
            </div>
          );
        } else {
          colorDot = (
            <div
              className={classes.colorDot}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div className={classes.NotConnected}></div>
              <div style={{ width: '10px' }} />
              <div style={{ color: colorCode.poor }}>Disconnected</div>
            </div>
          );
        }
        let deviceNameHtml;
        if (type === 'Desktop') {
          deviceNameHtml = (
            <td
              style={{
                padding: '16px',
                borderRight: 'none',
                borderLeft: 'none',
                borderBottom: '1px solid lightgray',
              }}
            >
              <div style={{ display: 'flex' }}>
                <input
                  id="moveDeviceCheckbox"
                  type="checkbox"
                  aria-label={"Move Device Checkbox"}
                  className={classes.DeviceCheckBox}
                  checked={
                    this.state.deviceMacs.get(data.mac) === null
                      ? false
                      : this.state.deviceMacs.get(data.mac)
                  }
                  name={data.mac}
                  value={data.mac}
                  onClick={this.handleMoveDeviceCheckBox}
                />
                <span className={classes.MoveDeviceWrapText}>
                  {this.getDeviceName(data)}{' '}
                </span>
              </div>
            </td>
          );
        } else {
          deviceNameHtml = '';
        }

        return (
          <tr>
            {deviceNameHtml}
            <td className={classes.MoveDeviceBorderLine}>{colorDot}</td>
            <td
              className={classes.MoveDeviceBorderLine}
              style={{ width: '100px' }}
            >
              <span
                style={{
                  wordWrap: 'normal',
                  display: 'block',
                  width: '235px',
                  whiteSpace: 'normal',
                }}
              >
                {this.getDeviceModel(data)}
              </span>
            </td>
            <td
              className={classes.MoveDeviceBorderLine}
              style={{ whiteSpace: 'pre' }}
            >
              {deviceGroupName}
            </td>
            <td className={classes.MoveDeviceBorderLine}>{paused}</td>
          </tr>
        );
      })
    );
  }
  renderFirstRowData() {
    const { devices } = this.props;
    let deviceGroups = this.getDeviceGroups();
    const { currentRecords } = this.state;

    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: '#6F777E',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
    };
    return (
      currentRecords &&
      currentRecords.map((data) => {
        let deviceGroupName = deviceGroups[data.mac];


        return (
          <tr>
            <td
              style={{
                padding: '8px',
                borderRight: 'none',
                borderLeft: 'none',
                borderBottom: '1px solid lightgray !important',
              }}
            >
              <div style={{ display: 'flex' }}>
                <input
                  type="checkbox"
                  aria-label={"Move Device Checkbox"}
                  className={classes.DeviceCheckBox}
                  checked={
                    this.state.deviceMacs.get(data.mac) === null
                      ? false
                      : this.state.deviceMacs.get(data.mac)
                  }
                  name={data.mac}
                  value={data.mac}
                  onClick={this.handleMoveDeviceCheckBox}
                />
                <span className={classes.MoveDeviceWrapText}>
                  {this.getDeviceName(data)}{' '}
                </span>
              </div>
            </td>
          </tr>
        );
      })
    );
  }
  renderTableInfo(type) {
    let sortIcon;
    const { sortDirection, sortBy, currentRecords } = this.state;
    if (sortDirection === 'desc') {
      sortIcon = <FaSortUp fontSize={'18px'} />;
    } else if (sortDirection === 'asc') {
      sortIcon = <FaSortDown fontSize={'18px'} />;
    }
    if (type === 'Desktop') {
      return (
        <React.Fragment>
          <thead>
            <tr>
              <th
                onClick={() => {
                  this.sortTable('deviceName');
                }}
              >
                Device Name {sortBy === 'deviceName' && sortIcon}
              </th>
              <th
                onClick={() => {
                  this.sortTable('deviceSignalStatus');
                }}
              >
                Signal {sortBy === 'deviceSignalStatus' && sortIcon}
              </th>
              <th
                onClick={() => {
                  this.sortTable('deviceModel');
                }}
              >
                Device Model {sortBy === 'deviceModel' && sortIcon}
              </th>
              <th
                onClick={() => {
                  this.sortTable('currentGroup');
                }}
              >
                Current Group {sortBy === 'currentGroup' && sortIcon}
              </th>
              <th
                onClick={() => {
                  this.sortTable('paused');
                }}
              >
                Pause {sortBy === 'paused' && sortIcon}
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRowData(type)}</tbody>
        </React.Fragment>
      );
    } else {
      let table1 = (
        <div style={{ float: 'left' }}>
          <table className={classes.devTable} cellPadding="0" cellSpacing="0">
            <thead>
              <tr className={classes.trTag}>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceName');
                  }}
                >
                  Device Name {sortBy === 'deviceName' && sortIcon}
                </th>
              </tr>
            </thead>
            <tbody>{this.renderFirstRowData()}</tbody>
          </table>
        </div>
      );
      let table2 = (
        <div className={classes.tableWrapper}>
          <table className={classes.devTable} cellPadding="0" cellSpacing="0">
            <thead>
              <tr className={classes.trTag}>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceSignalStatus');
                  }}
                >
                  Signal {sortBy === 'deviceSignalStatus' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('deviceModel');
                  }}
                >
                  Device Model {sortBy === 'deviceModel' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('currentGroup');
                  }}
                >
                  Current Group {sortBy === 'currentGroup' && sortIcon}
                </th>
                <th
                  style={{
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    padding: '16px',
                    color: 'grey',
                    borderBottom: '1px solid lightgrey',
                  }}
                  onClick={() => {
                    this.sortTable('paused');
                  }}
                >
                  Pause {sortBy === 'paused' && sortIcon}
                </th>
              </tr>
            </thead>
            <tbody>{this.renderRowData(type)}</tbody>
          </table>
        </div>
      );
      return (
        <div style={{ display: 'flex' }}>
          {table1}
          {table2}
        </div>
      );
    }
  }
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  confirmModalConfirmHandler = () => {
    let selectedMacs = [];
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        selectedMacs.push(mac);
      }
    });
    this.props.deviceGroups.forEach((data) => {
      if (data.id === this.state.selectedGroupId) {
        data.devices.forEach((device) => {
          selectedMacs.push(device.mac);
        });
      }
    });

    let payload = {
      grpAssignedDevices: selectedMacs,
      grpId: this.state.selectedGroupId,
      type: 'moveDevice',
    };
    this.props.changeDeviceGroupDetails(payload);
    this.confirmModalCancelHandler('close');
  };

  confirmModalCancelHandler = (e) => {
    this.setState({ confirmModal: false, deviceMacs: new Map() });
    if (e === 'close') {
      // this.props.closeGroupDetailsPage();
    }
  };

  moveDevicesGroupHandler = (e) => {
    let newDevicesToAdd = [];
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        this.props.devices.forEach((data) => {
          if (mac === data.mac) {
            newDevicesToAdd.push(data);
          }
        });
      }
    });
    const newGroup = this.props.deviceGroups
      .filter((group) => this.state.selectedGroupId === group.id);
    // console.log('newGroup ::::', newGroup, newDevicesToAdd );
    if ((newGroup[0].freeze.suspended.enable) || (!this.props.handleGroupSteering(newDevicesToAdd, 'MOVE_DEVICE', newGroup[0])) || (this.props.handleGroupSteering(newDevicesToAdd, 'MOVE_DEVICE', newGroup[0]))) {
      const modalContent = (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h2>Move Device</h2>
          <p style={{ fontWeight: 'normal', textAlign: 'center', margin: '2px' }}>
            Devices being moved to a new group will lose their current pause
            schedules and inherit the new group's schedule if one exists.
          </p>
          <p style={{ fontWeight: 'normal', textAlign: 'center', margin: '5px' }}>
            Are you sure you want to move the selected devices to this group?
          </p>
        </div>
      );
      this.onOpenModal(modalContent);
    }
  };

  render() {
    let showSaveBtn = true;
    this.state.deviceMacs.forEach((checked, mac) => {
      if (checked === true) {
        showSaveBtn = false;
      }
    });
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'#0073d1'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'#0073d1'} size={'30px'} />;
    }
    let options = [];
    let selectPlaceholder = '';
    if (this.props.deviceGroups) {
      options = this.props.deviceGroups
        .filter((group) => this.props.groupDetails.id !== group.id)
        .map((group, ind) => {
          let nickName = group.nickname.replace(/ /g, '\u00a0');
          if(group.id === this.state.selectedGroupId){
            selectPlaceholder = nickName;
          }
          return {
            value: group.id, label: nickName
          }
        });
    }
    let infoRow, moveGroupsHtml;
    if (this.state.noGroupsMsg) {
      moveGroupsHtml = (
        <div className={classes.MoveTo} style={{ display: 'flex' }}>
          <span style={{ padding: '10px' }}>Move To </span>
          <div id="moveDeviceText" className={classes.groupsMsg}>
            No available group to move at this time.
          </div>
        </div>
      );
    } else {
      moveGroupsHtml = (
        <div className={classes.MoveTo}>
          <div
            className={[classes.showMobile, classes.showSelectMobile].join(' ')}
          >
            <span style={{ padding: '10px 5px 10px  0px' }}>Move To </span>
            {/* <select
              className={classes.groupSelection}
              onChange={this.handleSelectedGroup}
              value={this.state.selectedGroupId}
              aria-label="Group Selection"
            >
              {optionsHtml}
            </select> */}
            <SelectDropdown
              height={'40px'}
              width={'auto'}
              name={this.state.selectedGroupName}
              title={this.state.selectedGroupName}
              aria-label="Group Selection"
              placeholder={selectPlaceholder}
              defaultValue={options?.filter(item => item.value === this.state.selectedGroupId)}
              value={this.state.selectedGroupId}
              isSearchable={false}
              onChange={(e) => this.handleSelectedGroup(e)}
              options={options}
            />
          </div>
          <button
            className={[classes.ActionButton, classes.showMobile].join(' ')}
            id="moveDeviceButton"
            disabled={showSaveBtn}
            onClick={this.moveDevicesGroupHandler}
          >
            Save
          </button>

          <div className={classes.showDesktop}>
            <span style={{ padding: '10px' }}>Move To </span>
            {/* <select
              className={classes.groupSelection}
              onChange={this.handleSelectedGroup}
              value={this.state.selectedGroupId}
              aria-label="Group Selection"
              title={this.state.selectedGroupName}
            >
              {optionsHtml}
            </select> */}
            <SelectDropdown
              height={'40px'}
              width={'auto'}
              name={this.state.selectedGroupName}
              title={this.state.selectedGroupName}
              aria-label="Group Selection"
              placeholder={selectPlaceholder}
              defaultValue={options?.filter(item => item.value === this.state.selectedGroupId)}
              value={this.state.selectedGroupId}
              isSearchable={false}
              onChange={(e) => this.handleSelectedGroup(e)}
              options={options}
            />
            <button
              className={classes.ActionButton}
              id="moveDeviceButton"
              disabled={showSaveBtn}
              onClick={this.moveDevicesGroupHandler}
            >
              Save
            </button>
          </div>
        </div>
      );
    }
    if (this.props.loading || !this.props.loaded) {
      infoRow = <Spinner />;
    } else if (
      !this.props.devices ||
      !this.props.groupDetails ||
      !this.props.groupDetails.devices
    ) {
      infoRow = (
        <div className={classes.InfoRow}>
          <div style={{ color: 'gray', textAlign: 'center' }}>
            No Device Information available to move at this time.
          </div>
        </div>
      );
    } else if (
      this.props.groupDetails &&
      this.props.groupDetails.devices.length === 0
    ) {
      infoRow = (
        <div className={classes.InfoRow}>
          <div style={{ color: 'gray' }}>
            No available devices can be move at this time.
          </div>
        </div>
      );
    } else {
      infoRow = (
        <Box>
          <div className={classes.showDesktop}>
            <div className={classes.tableWrapper}>
              <table
                className={classes.GroupDeviceTable}
                cellPadding="0"
                cellSpacing="0"
              >
                {this.renderTableInfo('Desktop')}
              </table>
            </div>
          </div>
          <div className={classes.showMobile}>
            {this.renderTableInfo('Mobile')}
          </div>
          {moveGroupsHtml}
        </Box>
      );
    }

    return (
      <div
        className={classes.MoveDeviceToGroupComponent}
        style={{ boxShadow: '#e2e1e1 0px 4px 2px -1px' }}
      >
        <div className={classes.showDesktop1}>
          <h2 style={{ margin: '1rem', fontSize: '16px' }}>Group Devices</h2>
          {infoRow}
        </div>
        <Modal
          deviceGroupConfirmation="true"
          show={this.state.confirmModal}
          modalClosed={this.confirmModalCancelHandler}
        >
          <Confirm
            id={'MoveDeviceToGroupConfirm'}
            deviceGroupConfirmation="true"
            action={this.state.action}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.devices.loading,
    loaded: state.devices.loaded,
    advancedDeviceIds: state.devices.advancedDeviceIds,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDeviceGroupDetails: (payload) =>
      dispatch(actions.changeDeviceGroupDetails(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(MoveDevicesToGroup, api));
